<template>
  <div class="padding-five-lr no-printme" style="background: #f8f8f8">
    <div>
      <b-row style="max-width: 100%">
        <b-col xs="12" sm="12" md="12" lg="4" class="padding-ten-tb">
          <h5 class="color-gray">GESTIÓN DE PROYECTOS</h5>
        </b-col>
      </b-row>
      <b-row style="max-width: 100%">
        <b-col xs="12" sm="12" md="12" lg="4">
          <h5 class="color-orange">Búsqueda</h5>
        </b-col>
      </b-row>
    </div>
    <div class="bg-white padding-five-all">
      <b-container fluid>
        <b-row>
          
          <b-col cols="12" lg="4" class="my-1">
            <b-form-group label="Tipo de documento" label-for="input-select">
              <b-form-select
                id="input-select"
                @change="clearParamsVal"
                v-model="selectedValue"
                size="md"
                :options="optionsTypeDoc"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col lg="4" class="my-1">
            <b-form-group
              label="Número de documento"
              label-for="input-doc"
              v-if="selectedValue == 'a'"
            >
              <b-form-input
                id="input-doc"
                type="text"
                v-model.trim="valueParams.dni"
                size="md"
                class="placeholder-black"
                placeholder="Ingrese el valor"
              ></b-form-input>
            </b-form-group>
         
            <b-form-group label="OS" label-for="input-os" v-else>
              <b-form-input
                id="input-os"
                type="text"
                v-model.trim="valueParams.sequenceOS"
                size="md"
                placeholder="Ingrese el valor"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col lg="6" class="my-1"> </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" lg="4" class="my-1">
            <label class="text-grey">Estado</label>
            <b-form-group>
              <b-form-select
                v-model="selectedState"
                size="md"
                :options="optionStates"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="12" lg="4" class="my-1">
            <label class="text-grey">Tienda</label>
            <combo-store
              v-model="selectedStore"
              v-bind:isComboSelected="false"
            ></combo-store>
          </b-col>
        
        </b-row>
        <b-row>
          <b-col lg="4" class="my-1">
            <label class="text-grey">Tipos de fecha</label>
            <b-form-group>
              <b-form-select
                v-model="selectedFilterDate"
                size="md"
                :options="optionsDate"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col lg="4" class="my-1">
            <label class="text-grey">Fecha inicio</label>
            <b-form-input type="date" v-model="startDate"></b-form-input>
          </b-col>
          <b-col lg="4" class="my-1">
            <label class="text-grey">Fecha fin</label>
            <b-form-input type="date" v-model="endDate"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="padding-ten-tb">
          <b-col cols="12" sm="12" md="12" lg="4" style="text-align: left">
            <b-button class="bg-grey-btn hidden-icon" @click="clearValues">
              <font-awesome-icon icon="broom" s /> LIMPIAR
            </b-button>
            <b-button
              @click="searchData"
              class="bg-orange-btn width-1000 padding-six-right"
            >
              <font-awesome-icon icon="search" /> BUSCAR
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="bg-white padding-five-all">
      <b-container fluid>
        <b-row>
          <b-col cols="12">
            <h5 class="color-orange">Resultados</h5>
          </b-col>
        </b-row>
        <!-- Main table element -->
        <b-table
          class="hidden-xs"
          show-empty
          small
          :busy="isBusy"
          striped
          :items="dataProjects"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          :filterIncludedFields="filterOn"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
        >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template #cell(nombres)="data">
            <span>{{ sliceNombres(data.item.nombres) }} </span>
          </template>

          <template v-slot:cell(actions)="row">
            <b-card class="border-none padding-none text-center">
              <b-row>
                <b-col
                  class="padding-none margin-none"
                  cols="auto">
                  
                   <b-button
                    
                    size="sm"
                    @click="getDetails(row.item, $event.target)"
                    class="mr-1 btn-orange-tra bg-grey color-dark"
                    v-b-tooltip.hover
                    title="Ver detalle"
                    ><font-awesome-icon icon="eye" />
                  </b-button>
                  <b-button
                    
                    size="sm"
                    @click="trackingOS(row.item)"
                    class="mr-1 btn-orange-tra bg-grey color-dark"
                    v-b-tooltip.hover
                    title="Tracking"
                    ><font-awesome-icon icon="file-medical-alt" />
                  </b-button>

                </b-col>
              </b-row>
            </b-card>
          </template>
        </b-table>
        <b-table
          class="show-xs"
          show-empty
          :busy="isBusy"
          striped
          stacked="sm"
          :items="dataProjects"
          :fields="fieldsTab"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          :filterIncludedFields="filterOn"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          thead-class="hidden_header"
          responsive
        >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template v-slot:cell(actions)="row">
            <b-card
              style="background: transparent"
              class="padding-none text-center"
            >
              <b-row>
                <b-col cols="10" class="text-sm-right">
                  <label class="color-orange" for="">N° OS </label>
                  <span class="color-orange">{{ row.item.sequence }} </span>
                </b-col>
                <b-col cols="2" style="text-align: right">
                  <b-button
                    style="
                      background: transparent;
                      color: #545b62;
                      border-color: transparent;
                    "
                    size="sm"
                    @click="row.toggleDetails"
                  >
                    <font-awesome-icon
                      :icon="row.detailsShowing ? 'chevron-up' : 'chevron-down'"
                    />
                  </b-button>
                </b-col>
              </b-row>
            </b-card>
          </template>
          <template #row-details="row">
            <b-card style="background: transparent">
              <b-row>
                <b-col cols="6" class="text-sm-right">
                  <label class="text-grey" for="">Estado</label>
                  <span>{{ row.item.state }} </span></b-col
                >
                <b-col cols="6" class="text-sm-right">
                  <label class="text-grey" for="">Doc. Identidad</label>
                  <span>{{ row.item.identityDocument }} </span></b-col
                >
                <b-col cols="6" class="text-sm-right">
                  <label class="text-grey" for="">Fecha estimada</label>
                  <span>{{ row.item.estimatedDate }} </span></b-col
                >
                <b-col cols="6" class="text-sm-right">
                  <label class="text-grey" for="">Turno</label>
                  <span>{{ row.item.turn }} </span></b-col
                >
              </b-row>
              <b-row>
                <b-col cols="6" class="text-sm-right">
                  <label class="text-grey" for="">Tienda</label>
                  <span>{{ row.item.storeDescription }} </span></b-col
                >
              </b-row>
              <b-row>
                <b-col
                  cols="auto"
                  v-for="(option, index) in optionsAdminOs"
                  :key="index"
                >
                  <b-button
                    v-if="option.name === 'DetalleOS'"
                    size="md"
                    @click="getDetails(row.item, $event.target)"
                    class="mr-1 btn-orange-tra bg-grey color-dark"
                    v-b-tooltip.hover
                    title="Ver detalle"
                    ><font-awesome-icon icon="eye" />
                  </b-button>

                  <b-button
                    v-if="option.name === 'TrackingOS'"
                    size="md"
                    @click="trackingOS(row.item)"
                    class="mr-1 btn-orange-tra bg-grey color-dark"
                    v-b-tooltip.hover
                    title="Tracking"
                    ><font-awesome-icon icon="file-medical-alt" />
                  </b-button>

                  <b-button
                    v-if="option.name === 'ImpresionOS'"
                    :disabled="row.item.state == 'PENDIENTE_CREACION'"
                    size="md"
                    @click="printOS(row.item, $event.target)"
                    class="mr-1 btn-orange-tra bg-grey color-dark"
                    v-b-tooltip.hover
                    title="Impresión"
                  >
                    <font-awesome-icon icon="print" />
                  </b-button>
                </b-col>
                <b-col cols="auto">
                  <b-dropdown
                    id="dropdown-offset"
                    dropleft
                    dropup
                    offset="-125"
                    size="lg"
                    variant="color-dark"
                    toggle-class="text-decoration-none "
                    no-caret
                  >
                    <template #button-content>
                      <font-awesome-icon icon="ellipsis-v" />
                    </template>
                   
                  </b-dropdown>
                </b-col>
              </b-row>
            </b-card>
          </template>
        </b-table>
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          pills
          limit="4"
          first-number
          hide-goto-end-buttons
          align="center"
          size="md"
          class="my-0"
        ></b-pagination>
      </b-container>
    </div>
    <div>   
      
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { mapState } from "vuex";

import ComboStore from "../../components/ComboStore.vue";
import moment from "moment";
import store from "@/store";
export default {
  name: "Proyectos",
  data() {
    return {
      currentPage: 1,
      totalRows:1,
      itemsData:[],
      dataSelected:"",
      propertiesModal: { show: false, message: "", hasError: false },
      detailId: null,
      fields: [
        {
          key: "id",
          label: "N° Proyecto",
          sortDirection: "desc",
        },
        {
          key: "desc_Estado",
          label: "Estado",
          sortable: true,
        },
        {
          key: "desc_SubEstado",
          label: "Sub Estado",
        },
        {
          key:"nombres",
          label:"Nombres"
        },
        { key: "fechaRegistro", label: "F. Creación" },
        { key: "osOrigen", label: "OS VT" },
        { key: "id_os_instalacion", label: "OS Instalación" },
        { key: "docIdentidad", label: "Doc. Identidad" },

        { key: "actions", label: "" },
      ],
      fieldsTab: [{ key: "actions", label: "" }],
      optionsTypeDoc: [
        { value: "a", text: "Doc. Identidad" },
        { value: "a", text: "RUC" },
        { value: "c", text: "N° OS V.T" },
      ],
      optionsTypeOs: [
        { value: null, text: "TODOS" },
        { value: "VTEC", text: "VISITA TÉCNICA" },
        { value: "VINS", text: "VISITA INSPECCIÓN" },
      ],
      selectedTypeOs: null,
      selectedValue: "a",
  
      optionStates:[
      { value: null, text: "TODOS" },
        { value: "1", text: "Pendiente" },
        { value: "2", text: "En proceso" },
        { value: "3", text: "Finalizado" }
        ],
      selectedState: null,
      optionsDate: [
        { value: "a", text: "Fecha de creación" }
      ],
      selectedFilterDate: "a",
      selectedStore: 0,
      valueParams: {
        dni: null,
        sellerNote: "",
        sequenceOS: "",
        typeOs: "",
      },
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      countTotal: 500,
      perPage: 10,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      isBusy: false,
      valuesForm: { detailId: "" },
      valuesProg: { detailId: "", providerId: "" },
      idTechInform: "",
      idInspectionReport: "",
      optionsProvider: [],
      selectedProvider: 0,
      selectedProviderUser: null,
      countRecords: 20
    };
  },
  beforeRouteEnter(to, from, next) {
    let menu = store.getters["module/optionsMenu"];
    let perfil = store.getters["module/profile"];
    let authProvider = menu.some((m) => m.id ==39);
    if (authProvider&&perfil!=="PROVEEDOR") next();
    else next({ name: "BlockedPage" });
  },
  components: {
  
    ComboStore,
    
  },
  computed: {
      isProfileProvider() {
      let up = this.perfil.toUpperCase();
      if (up === "PROVEEDOR") return true;
      return false;
    },
    rowsTable() {
      if (this.currentPage == 1 && this.itemsData.length < 10) return 10;
      return this.countRecords;
    },
    
    ...mapState({
      dataProjects: (state) => state.dataProjects,
    }),
    ...mapState("module", [
      "perfil",
      "idProvider",
      "username",
      "store",
      "options",
      "token"
    ]),
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },


  },
  watch: {
    /*currentPage: {
      handler: function() {
        this.searchData()
          .then((res) => {
            if (res.length < 10) return;
            this.countRecords = this.countRecords + 20;

            console.log(this.countRecords, res);
          })
          .catch((error) => {
            console.error(error);
          });
      },
    }, */
  },
  created() {

    ///this.selectedStore = this.store[0].codigo;
  },

  methods: {
    
  sliceNombres(nombres){
      if(nombres){
        return nombres.slice(0,10)
      }
      return ""
    },
    setValues(item){

      this.dataSelected=item;
    },

    onHiddenModal() {
      if (this.detailId) this.detailId = null;
      if (this.valuesProg.detailId) this.valuesProg.detailId = null;
      if (this.valuesProg.providerId) this.valuesProg.providerId = null;
    },
   
  
    setValuesResponse(selected) {
      this.propertiesModal.show = selected.show;
      this.propertiesModal.message = selected.message;
      this.propertiesModal.hasError = selected.hasError;
    },
    formatDateV2(val) {
      return moment(val, "DD/MM/YYYY").format("DD/MM/YYYY");
    },
    formatDate(val) {
      return moment(val).format("DD/MM/YYYY");
    },
    setOptionSelected(selected) {
      if (selected.length) {
        this.selectedProvider = selected[0].id;
        this.selectedProviderUser = selected[0].user;
      }
    },

    setDetailId(item) {
      this.detailId = item.detailId;
    },
    clearValues() {
      this.valueParams.dni = "";
      this.valueParams.sellerNote = "";
      this.valueParams.sequenceOS = "";
      this.selectedProvider = 0;
      this.selectedStore = 0;
      this.startDate = "";
      this.endDate = "";
      this.selectedProviderUser = null;
    },




    clearParamsVal() {
      this.valueParams.dni = "";
      this.valueParams.sellerNote = "";
      this.valueParams.sequenceOS = "";
    },
    getDetails(item) {
      this.$router.push({ name: 'DetalleProyecto',params:
       { os: item.osOrigen,informe:item.idReport,id:item.id} });
      //this.$router.push({ path: `/detalle-proyecto/${item.osOrigen}` });
    },

    trackingOS(item) {
      this.$router.push({ path: `/tracking-proyecto/${item.id}` });
    },
    async searchData() {
      
      this.isBusy = true;

      let startDate =
        this.selectedFilterDate == "a"
          ? "&fechaInicio=" + this.startDate
          : "&fechaInicio=" + this.startDate;
      let endDate =
        this.selectedFilterDate == "a"
          ? "&fechaFin=" + this.endDate
          : "&fechaFin=" + this.endDate;
          let state =
        this.selectedState
          ? "&estado=" + this.selectedState
          : "&estado=0" 
          let numOs=
           this.valueParams.sequenceOS
          ? "&os=" + this.valueParams.sequenceOS
          : "" 
          let store=this.selectedStore? "&tienda=" + this.selectedStore
          : "&tienda=0" 
          let docIdentidad=this.valueParams.dni? "&docIdentidad=" + this.valueParams.dni
          : "" 
      try {
        let response = await axios.get(
          
            process.env.VUE_APP_PROJECT_BASE+"?subestado=0"+state +startDate+endDate+numOs+store+docIdentidad,
            {
            headers: {
              "Content-type": "application/json"
            },
          }
        );
        
        console.log(response.data);
        this.itemsData = response.data;
        this.$store.commit("SET_DATA_PROJECTS", response.data);
        this.totalRows = this.itemsData.length
        return response.data;
        //this.detailsOS = response.data;
      } catch (error) {
        if (!error.response) {
          // alert("error");
        }

        console.log(error);
      } finally {
        this.isBusy = false;
      }
    },
    filterOrderServices(order) {
      if (this.perfil === "PROVEEDOR") {
        const filteredArr = order.filter(
          (o) =>
            o.state != "PENDIENTE_CREACION" &&
            o.state != "PENDIENTE_PAGO" &&
            o.state != "PENDIENTE_REPROGRAMACION"&&
            o.state != "ANULADA"
        );
        return filteredArr;
      }
      return order;
    },
  },
};
</script>
<style scoped>

::v-deep .card-body {
  padding: 0;
}
::v-deep .text-modal-aprobar h5 {
  color: #ff7a00;
}
::v-deep .text-modal-reprogramar h5 {
  color: #ff7a00;
}
::v-deep .text-modal-confirmar h5 {
  color: #ff7a00;
}
::v-deep .text-modal-aprobar h5 {
  color: #ff7a00;
}
::v-deep .text-modal-anular h5 {
  color: #e73860;
}
.bg-grey-btn {
  background-color: #676767;
  border-radius: 20px;
}
.bg-grey {
  background-color: #ececec;
  border-color: transparent;
}
::v-deep .btn-color-dark {
  color: #bbbbbb;
}
.color-dark {
  color: #bbbbbb;
}

.padding-two-top {
  padding-top: 2.5%;
}
.btn-orange-tra {
  border-radius: 50%;
}
.form-control {
  border: none;
  border-bottom: 1px solid #ced4da;
  padding: 5px 10px;
  outline: none;
  border-radius: 0;
}
::v-deep.color-purple .dropdown-item {
  color: #e73860 !important;
}

::v-deep .page-item.active .page-link {
  background: #ff7a00;
  color: white;
  border-color: transparent;
}
::v-deep label {
  margin-bottom: 0;
  color: #676767;
  font-size: 15px;
  letter-spacing: 0;
}
::v-deep .page-item.disabled .page-link {
  background: transparent !important;
  border-color: transparent !important;
  color: #ff7a00;
}
::v-deep .page-link {
  color: #676767;
  border-color: transparent;
  font-weight: bold;
  background: transparent;
}

::v-deep #input-group-3__BV_label_ {
  color: #676767;
  font-size: 15px;
  letter-spacing: 0px;
  display: block;
  margin-bottom: 0;
}
.color-orange {
  color: #ff7a00;
}
.padding-six-right {
  margin-left: 20px;
}

.padding-ten-lr {
  padding: 10px;
  padding-left: 35px !important;
}

.color-gray {
  color: #676767;
  font-weight: bold;
}
.show-xs {
  display: none;
}
.btn-transparent {
  background: transparent !important;
  border-color: transparent !important;
}
::v-deep .b-table thead {
  background-color: transparent !important;
  color: black !important;
  font-weight: 500 !important;
  border: none !important;
}
::v-deep .table tr:first-child td {
  border-top: 1px solid transparent !important;
}
::v-deep .b-table thead th {
  font-weight: 700 !important;
  border: none !important;
  font-size: 11pt;
}
::v-deep .table td {
  color: black;
  font-size: 11pt;
}
::v-deep .table-striped tbody tr:nth-of-type(odd) {
  background-color: transparent;
}

@media (max-width: 645px) {
  .card {
    border-color: transparent !important;
  }
  .show-xs {
    visibility: visible;
  }
  .hidden-xs {
    display: none;
  }
  .padding-five-lr {
    padding-left: 0 !important;
    padding-right: 0;
  }
  .text-right-md {
    text-align: left !important;
    padding-top: 10px;
  }
}
.text-right-md {
  text-align: right;
}

#modal-informe-vins___BV_modal_header_{
    visibility: hidden !important;
  }
</style>
